import styled from "styled-components";

export const ModalBody = styled.div`
  text-align: center;
  padding: 8px 0;
`;

export const Icone = styled.div`
  margin: auto;
  margin-bottom: 16px;
  font-size: 42px;

  svg {
    background-color: #e6f9f0;
    color: #28a745;
    border-radius: 12px;
    padding: 10px;
  }
`;

export const Subtexto = styled.div`
  margin-top: 8px;
  font-size: 0.85rem;
  color: #6b7280;
`;
